function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useRef, useState } from "react";
import Divider from "sprout-ui-dom/dist/Divider";
import { Box, Flex } from "sprout-ui-primitives";
import { themeGet } from "sprout-ui-theme";
import styled, { css, keyframes } from "styled-components";
import { visuallyHiddenStyle } from "sprout-ui-dom/dist/utils";
const shimmer = keyframes`
  0% {
    opacity: 0.25;
  }
  100% {
    opacity: 1;
  }
`;
const shimStyles = css`
  animation-name: ${shimmer};
  animation-duration: 1s;
  opacity: 0.25;
  animation-iteration-count: infinite;
  animation-direction: alternate;
  animation-timing-function: steps(10, end);
  background: ${themeGet("colors.black.6")};
`;
const ShimmerBox = styled(Box)`
  ${shimStyles};
`;
function createTwitterScriptTag() {
    return _createTwitterScriptTag.apply(this, arguments);
}
function _createTwitterScriptTag() {
    _createTwitterScriptTag = _asyncToGenerator(function*() {
        return new Promise((resolve)=>{
            if (window.twttr) resolve(window.twttr);
            const id = "twitter-wjs";
            const exists = document.getElementById(id);
            let script;
            // Already added to the DOM, might be fetching
            if (exists) script = exists;
            else {
                script = document.createElement("script");
                script.id = id;
                script.src = "https://platform.twitter.com/widgets.js";
                script.async = true;
                document.body.appendChild(script);
            }
            script.onload = ()=>{
                resolve(window.twttr);
            };
        });
    });
    return _createTwitterScriptTag.apply(this, arguments);
}
function removeAllChildNodes(element) {
    while(element.firstChild)element.removeChild(element.firstChild);
}
const UrlDisplayTwitter = (props)=>{
    const { tweetId  } = props;
    const containerRef = useRef(null);
    const [loading, setLoading] = useState(true);
    useEffect(()=>{
        const container = containerRef.current;
        createTwitterScriptTag().then((twttr)=>{
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            return twttr.ready();
        }).then(({ widgets  })=>{
            return widgets.createTweet(tweetId, container);
        }).then(()=>{
            setLoading(false);
        });
        return ()=>{
            setLoading(true);
            if (container) removeAllChildNodes(container);
        };
    }, [
        tweetId
    ]);
    return /*#__PURE__*/ _jsxs("div", {
        children: [
            /*#__PURE__*/ _jsx(Flex, {
                /*
         * Why is this needed? When Twitter's embed first initialize, it initializes
         * with some padding/margin on the `iframe`. This causes a jitter effect
         * as it pushes the placeholder down the viewport.
         *
         * Note: Do not attempt to use `display: none` here. It will not work in Chrome
         * for unknown reasons.
         */ style: loading ? visuallyHiddenStyle : undefined,
                alignItems: "center",
                justifyContent: "center",
                ref: containerRef
            }),
            loading && /*#__PURE__*/ _jsxs(Box, {
                maxWidth: "550px",
                height: "220px",
                my: "10px",
                mx: "auto",
                borderRadius: "12px",
                borderWidth: "1px",
                borderStyle: "solid",
                borderColor: "black.12",
                p: "8px 16px",
                children: [
                    /*#__PURE__*/ _jsxs(Flex, {
                        alignItems: "center",
                        children: [
                            /*#__PURE__*/ _jsx(ShimmerBox, {
                                width: "48px",
                                height: "48px",
                                borderRadius: "50%"
                            }),
                            /*#__PURE__*/ _jsxs(Box, {
                                ml: 1,
                                flex: "1",
                                minWidth: "0",
                                children: [
                                    /*#__PURE__*/ _jsx(ShimmerBox, {
                                        height: "14px",
                                        width: "40%"
                                    }),
                                    /*#__PURE__*/ _jsx(ShimmerBox, {
                                        height: "14px",
                                        width: "20%",
                                        mt: 1
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsxs(Box, {
                        mt: 4,
                        children: [
                            /*#__PURE__*/ _jsx(ShimmerBox, {
                                height: "16px",
                                width: "60%"
                            }),
                            /*#__PURE__*/ _jsx(ShimmerBox, {
                                height: "16px",
                                width: "80%",
                                mt: 1
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsx(Divider, {
                        height: "1px",
                        mt: 4,
                        mb: 2,
                        bg: "black.12"
                    }),
                    /*#__PURE__*/ _jsxs(Flex, {
                        alignItems: "center",
                        children: [
                            /*#__PURE__*/ _jsx(ShimmerBox, {
                                height: "14px",
                                width: "70px"
                            }),
                            /*#__PURE__*/ _jsx(ShimmerBox, {
                                height: "14px",
                                width: "70px",
                                mx: 4
                            }),
                            /*#__PURE__*/ _jsx(ShimmerBox, {
                                height: "14px",
                                width: "70px"
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsx(ShimmerBox, {
                        height: "20px",
                        width: "100%",
                        mt: 4
                    })
                ]
            })
        ]
    });
};
export default UrlDisplayTwitter;
